import { render, staticRenderFns } from "./AgentForm.vue?vue&type=template&id=0cdaadd5"
import script from "./AgentForm.vue?vue&type=script&lang=js"
export * from "./AgentForm.vue?vue&type=script&lang=js"
import style0 from "./AgentForm.vue?vue&type=style&index=0&id=0cdaadd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports